import { prepareTags } from "../../utils/commonUtility";
import Like from "./Like";
import SaveUnSave from "./SaveUnSave";

export default function BlogDescription ({blog}) {
    const { id, image, title, tags, likes, isSaved, description } = blog || {};
    const tagList = prepareTags(tags);

    return (
        <main className="post">
            <img
                src={image}
                alt="githum"
                className="w-full rounded-md"
                id="lws-megaThumb"
            />
            <div>
                <h1
                    className="mt-6 text-2xl post-title"
                    id="lws-singleTitle"
                >
                    {title}
                </h1>
                <div className="tags" id="lws-singleTags">
                    {tagList}
                </div>
                <div className="btn-group">
                    <Like id={id} likes={likes} />
                    <SaveUnSave id={id} isSaved={isSaved} />
                </div>
                <div className="mt-6">
                    <p>{description}</p>
                </div>
            </div>
        </main>
    );
}